/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { NotificationService } from 'app/services/notification.service';
import { NotificationSettings } from 'app/models/notification-settings';
import { getDataItemId, getDataItemOs } from 'app/functions/data-item-helpers';
import { NotificationSettingsComponent } from '../shared/notification-settings/notification-settings.component';

@Component({
  selector: 'app-app-list-view',
  templateUrl: './app-list-view.component.html',
  styleUrls: ['./app-list-view.component.scss']
})
export class AppListViewComponent implements OnInit {
  @Input() reportViewType: string;
  @Input() currentConfig: any;
  @Input() showDetails: boolean;
  @Input() searchEnabled = true;
  @Input() gridData: Array<any>;
  @Input() showLoadMore: boolean;
  @Input() showLoadingMore: boolean;
  @Input() showFollowing: boolean;
  @Input() isFreemium: boolean;
  @Input() notificationSettings: Array<NotificationSettings>;
  @Output() loadMoreClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() toggleSortClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() unfollowItem: EventEmitter<any> = new EventEmitter<any>();
  @Output() appGlobalSearch: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearAppGlobalSearch: EventEmitter<any> = new EventEmitter<any>();
  @Input() appGlobalSearchParamModel: string;
  appGlobalSearchParamUpdate: Subject<string> = new Subject<string>();

  constructor(
    private modalService: NgbModal,
    private _notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.appGlobalSearchParamUpdate
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe(() => {
        this.appGlobalSearchClick();
      });
  }

  appGlobalSearchClick() {
    this.appGlobalSearch.emit(this.appGlobalSearchParamModel);
  }

  clearAppGlobalSearchClick() {
    this.appGlobalSearchParamModel = null;
    this.clearAppGlobalSearch.emit(true);
  }

  toggleSort(header: any) {
    if (header.lockedInFreemium && this.isFreemium) return;
    if (!(this.currentConfig.key === 'apps' && header.key === 'appTitle')) {
      this.toggleSortClick.emit(header);
    }
  }

  loadMore() {
    this.loadMoreClick.emit(true);
  }

  async enableNotification(dataItem) {
    const dataItemId = getDataItemId(dataItem);
    await this._notificationService
      .adjustNotificationSetting(dataItemId, getDataItemOs(dataItem), null)
      .then(data => {
        if (data.status == 'ok' && data.adjusted > 0) {
          this.notificationSettings = this.notificationSettings.concat({
            id: dataItemId
          });
        }
      });
  }

  async disableNotification(dataItem) {
    const dataItemId = getDataItemId(dataItem);
    await this._notificationService
      .deleteNotificationSetting(dataItemId, getDataItemOs(dataItem))
      .then(data => {
        if (data.status == 'ok' && data.deleted > 0) {
          this.notificationSettings = this.notificationSettings.filter(
            d => d.id != dataItemId
          );
        }
      });
  }

  editNotification(dataItem) {
    const modalRef = this.modalService.open(NotificationSettingsComponent);
    modalRef.componentInstance.data = dataItem;
  }

  viewUpdates(dataItem) {}

  unfollow(dataItem) {
    console.debug('DATAITEM: ', dataItem);
    this.unfollowItem.emit(dataItem);
  }
}
